import React from 'react';
import { bonuses } from '../data/bonuses';
import { OFFER_ANCHOR } from './constants';
export function BonusSection() {
  return <section className="border-y border-eq-line bg-eq-light px-3 py-3 sm:px-4 sm:py-4" data-id="element-16" data-mp="1ofc5fttsurgy">
      <div className="mx-auto max-w-4xl" data-id="element-17" data-mp="22ebu31hbb6d4">
        <h2 className="mb-1.5 text-center font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-18" data-mp="22dagoqctq7s8">
          🎁 5 Premium Bonuses Included
        </h2>
        <div className="grid gap-1.5 sm:grid-cols-2 sm:gap-2" data-id="element-19" data-mp="1aop9uajc5hp3">
          {bonuses.map(bonus => <a key={bonus.title} href={OFFER_ANCHOR} className="rounded-lg border border-eq-gold/70 bg-white p-2.5 shadow-sm transition-colors duration-150 ease-out hover:border-eq-navy sm:p-3" data-id="element-20" data-mp="15n9la8hy8t1y">
              <h3 className="font-display text-[13px] font-extrabold uppercase leading-tight text-eq-navy sm:text-base" data-id="element-21" data-mp="qzoh0b9c8nsg">
                {bonus.title}
              </h3>
              <p className="mt-0.5 text-[12px] font-medium leading-snug text-eq-muted sm:text-sm" data-id="element-22" data-mp="29s30j90wnf8j">
                {bonus.description}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}